import React from 'react';
import Footer from '../../../layouts/MainFrame/Footer/Footer';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import ProfileHeaderWrapper from '../../../layouts/Header/HeaderLayout';

const Error404 = () => {
    const { t } = useTranslation('errors');

    return (
        <>
            <>
                <ProfileHeaderWrapper />
                <Box sx={{ padding: '0 3.175%' }}>
                    <h1>{t('ERROR.ERROR_404')}</h1>
                    <p>{t('ERROR.ERROR_404_CONTENT')}</p>
                </Box>
                <Footer />
            </>
        </>
    );
};

export default Error404;
